export const numberConverter = (price: number | undefined) => {
  if (typeof price === 'number') {
    return String(price).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
  }
};